import { useEffect, useState } from 'react';
import { internetApi } from '../services/apiServices/user/internet';
import { AccountTypes } from '../models/Common';
import { IUserAvailableServices } from '../models/Accounts';
import { iptvApi } from '../services/apiServices/user/iptv';
import { ctvApi } from '../services/apiServices/user/ctv';
import { unionApi } from '../services/apiServices/user/union';

const initialState: IUserAvailableServices = {
  types: [],
};

export const useAvailableServices = (accountId: number | string, accountType: AccountTypes | '') => {
  const [availableServices, setAvailableServices] = useState<IUserAvailableServices>(initialState);
  const { data: internetServices } = internetApi.useGetAvailableInternetServicesQuery(
    { accountId: `${accountId}` },
    { skip: accountType !== AccountTypes.Internet },
  );
  const { data: iptvServices } = iptvApi.useGetAvailableIptvServicesQuery(
    { accountId: `${accountId}` },
    { skip: accountType !== AccountTypes.Iptv },
  );
  const { data: ctvServices } = ctvApi.useGetAvailableCtvServicesQuery(
    { accountId: `${accountId}` },
    { skip: accountType !== AccountTypes.Ctv },
  );
  const { data: unionServices } = unionApi.useGetAvailableUnionServicesQuery(
    { accountId: `${accountId}` },
    { skip: accountType !== AccountTypes.Union },
  );

  const typedServices = internetServices ?? iptvServices ?? ctvServices ?? unionServices;

  useEffect(() => {
    setAvailableServices(typedServices ?? initialState);
  }, [internetServices, iptvServices, ctvServices, unionServices]);

  return availableServices;
};
